import { render, staticRenderFns } from "./FenXiaoAudit.vue?vue&type=template&id=058675a0&"
import script from "./FenXiaoAudit.vue?vue&type=script&lang=js&"
export * from "./FenXiaoAudit.vue?vue&type=script&lang=js&"
import style0 from "./FenXiaoAudit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports